// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import config from 'pub_config';

const {url2md5} = config;
type t_site = 'hola' | 'toolip' | 'oculus' | 'browserai';
export const img_url = (name: string, site: t_site = 'hola')=>
    url2md5(`/www/${site}/pub/img/${name}`);
